import { styled } from "@mui/material/styles";

export const ColumnDateShow = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  padding: "0px 8px",
}));

export const ColumnStatus = styled("div")(() => ({
  position: "relative",
  "& > div": {
    width: "fit-content",
  },
}));
